<template>
    <div class="box box-pack-between main">
        <sort-label-show title="分类标签" :list="treeList" @nodeClick="getNodeIds" @handleDragEnd="handleDragEnd"
            @createTag="createTagEvent" @delLabel="delLabel" ref="sortLabel"></sort-label-show>
        <div class="flex1">
            <div class="mr-title" style="font-size: 18px;padding-left: 17px;">分类下的内容</div>
            <div class="whiteBg height100 main-right">
                <el-select v-model="sortVal" @change="changeSort" placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <dy-table :columns="columns" style="margin-top: 12px;" :table-data="tableData" ref="table"
                    v-loading="tableLoading" :total="total" :page-num="currentPage" :page-size="10"
                    @current-change="onCurrentChange" element-loading-text="加载中"></dy-table>
            </div>
        </div>
    </div>
</template>
<script>
import DyTable from '@/components/common/dytable'
import sortLabelShow from '@/components/common/sortLabelShow'

import { getCourseCategory, getTextList, deleteCourseCategory, addCourseCategory, getCourseList, selectListByCategory } from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';

var that = null;
export default {
    data() {
        return {
            tableLoading: true,
            columns: [
                {
                    type: 'index',
                    title: '序号'
                },
                {
                    key: 'id',
                    title: '课程编号'
                },
                {
                    key: 'textName',
                    title: '课程名称'
                },
                {
                    key: 'bgUserName',
                    title: '操作人'
                },
                {
                    key: 'updateDate',
                    title: '发布时间'
                }
            ],
            tableData: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            treeList: [],
            sortVal: '1',
            options: [
                {
                    value: '1',
                    label: '课程'
                },
                {
                    value: '2',
                    label: '课文'
                },
                {
                    value: '3',
                    label: '资源'
                }
            ]
        }
    },
    components: {
        sortLabelShow,
        DyTable
    },
    mounted() {
        that = this;
        that.getCourseCategory();
    },
    methods: {
        changeSort(e) {
            console.log(e);
            that.currentPage = 1;
            switch (parseInt(e)) {
                case 1://课程
                    that.columns = [
                        {
                            type: 'index',
                            title: '序号'
                        },
                        {
                            key: 'id',
                            title: '课程编号'
                        },
                        {
                            key: 'textName',
                            title: '课程名称'
                        },
                        {
                            key: 'bgUserName',
                            title: '操作人'
                        },
                        {
                            key: 'updateDate',
                            title: '发布时间'
                        }
                    ];
                    that.getCourseList();
                    break;
                case 2://课文
                    that.columns = [
                        {
                            type: 'index',
                            title: '序号'
                        },
                        {
                            key: 'id',
                            title: '课文编号'
                        },
                        {
                            key: 'textName',
                            title: '课文名称'
                        },
                        {
                            key: 'bgUserName',
                            title: '操作人'
                        },
                        {
                            key: 'updateDate',
                            title: '发布时间'
                        }
                    ];
                    that.getList4class();
                    break;
                case 3://资源
                    that.columns = [
                        {
                            type: 'index',
                            title: '序号'
                        },
                        {
                            key: 'id',
                            title: '资源编号'
                        },
                        {
                            key: 'textName',
                            title: '资源名称'
                        },
                        {
                            key: 'bgUserName',
                            title: '操作人'
                        },
                        {
                            key: 'updateDate',
                            title: '发布时间'
                        }
                    ];
                    that.selectListByCategory();
                    break;
            }
        },
        //节点拖动
        handleDragEnd(draggingNode, dropNode) {
            console.log('节点拖动', draggingNode.label, dropNode.label);
            that.saveClassification(draggingNode.data.value, draggingNode.data.label, dropNode.data.value);
        },
        //节点点击
        getNodeIds(id) {
            console.log(id);
            that.categoryId = id;
            that.changeSort(parseInt(that.sortVal));
        },
        //切换页面
        onCurrentChange(val) {
            that.currentPage = val;
            that.getList4class();
        },
        // 创建标签
        createTagEvent(obj) {
            that.saveClassification(obj.id, obj.name, obj.parentId);
        },
        //删除标签
        delLabel(id) {
            console.log('删除标签', id);
            that.$confirm('确认要删除此标签吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let info = {
                    id,//分类id
                };
                var data = encrypt(JSON.stringify(info));
                deleteCourseCategory(data).then((res) => {
                    that.$message({
                        showClose: true,
                        message: '删除成功',
                        type: 'success'
                    });
                    that.getCourseCategory();
                });
            })
        },
        // 添加/修改文章分类
        saveClassification(id, name, parentId) {
            console.log('before', id, name, parentId);
            parentId = id == parentId ? 0 : parentId;
            let info = {
                id,//分类id
                name,//分类名称
                parentId,//父节点ID
                type: 1
            };
            var data = encrypt(JSON.stringify(info));
            addCourseCategory(data).then((res) => {
                if (res.result == 1) {
                    that.$refs.sortLabel.closeDialog();
                    that.$message({
                        showClose: true,
                        message: '添加成功',
                        type: 'success'
                    });
                    that.getCourseCategory();
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        //获取课程列表
        getCourseList() {
            let info = {
                categoryId: that.categoryId || '',
                page: that.currentPage,
                pageSize: that.pageSize,
                needPage: true
            };
            console.log(info);
            var data = encrypt(JSON.stringify(info));
            getCourseList(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));
                    console.log('获取课程列表', ress);
                    that.tableData = ress.list.map(item => {
                        return {
                            ...item,
                            textName: item.courseTitle
                        }
                    });
                    that.total = ress.total;
                    that.tableLoading = false;
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        //获取课文列表
        getList4class() {
            let info = {
                categoryId: that.categoryId || '',
                page: that.currentPage,
                pageSize: that.pageSize,
            };
            console.log(info);
            var data = encrypt(JSON.stringify(info));
            getTextList(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));
                    console.log('获取课文列表', ress);
                    that.tableData = ress.list.map(item => {
                        return {
                            ...item,
                            textName: item.textName
                        }
                    });;
                    that.total = ress.total;
                    that.tableLoading = false;
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        //获取资源列表
        selectListByCategory() {
            let info = {
                categoryId: that.categoryId || '',
                page: that.currentPage,
                pageSize: that.pageSize,
            };
            console.log(info);
            var data = encrypt(JSON.stringify(info));
            selectListByCategory(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));
                    console.log('获取资源列表', ress);
                    that.tableData = ress.list.map(item => {
                        return {
                            ...item,
                            textName: item.fileName
                        }
                    });
                    that.total = ress.total;
                    that.tableLoading = false;
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        //获取所有分类(树型结构)
        getCourseCategory() {
            let info = {
                type: 1,
            };
            var data = encrypt(JSON.stringify(info));
            getCourseCategory(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));
                    console.log('获取所有分类', ress);
                    if (ress.length > 0) {
                        that.treeList = that.listFor(ress);
                        that.currentPage = 1;
                        that.categoryId = that.treeList[0].value;
                        switch (parseInt(that.sortVal)) {
                            case 1://课程
                                that.getCourseList();
                                break;
                            case 2://课文
                                that.getList4class();
                                break;
                            case 3://资源
                                that.selectListByCategory();
                                break;
                        }
                    }
                    that.tableLoading = false;
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        listFor(arr) {
            let children = [];
            if (arr != null && arr != '' && arr != undefined) {
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].childCourseCategory != '' && arr[i].childCourseCategory != null && arr[i].childCourseCategory != undefined) {
                        children.push({
                            value: arr[i].id,
                            label: arr[i].name,
                            children: this.listFor(arr[i].childCourseCategory),
                        });
                    } else {
                        children.push({
                            value: arr[i].id,
                            label: arr[i].name,
                            children: this.listFor(arr[i].childCourseCategory),
                        });
                    }
                }
            } else {
                return;
            }
            return children;
        },
    }
}
</script>
<style lang="scss" scoped>
.main {
    padding: 17px;

    .main-right {
        flex: 1;
        overflow: hidden;
        margin-left: 16px;
        padding: 24px;
        overflow-y: scroll;
        margin-top: 12px;
    }
}
</style>